"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Three3D = exports.MIN_DISTANCE_MULTIPLIER = exports.MAX_DISTANCE_MULTIPLIER = exports.DEFAULT_TEXTURE_SIZE = void 0;
var _three = require("three");
var _tween = _interopRequireDefault(require("@tweenjs/tween.js"));
var _first = _interopRequireDefault(require("lodash/first"));
var _findIndex = _interopRequireDefault(require("lodash/findIndex"));
var _ThreeBase2 = require("./ThreeBase");
var _MTLLoader = _interopRequireDefault(require("./Loaders/MTLLoader"));
var _OBJLoader = _interopRequireDefault(require("./Loaders/OBJLoader"));
var _ColladaLoader = _interopRequireDefault(require("./Loaders/ColladaLoader"));
var _initTextureCanvas = require("../Utils/initTextureCanvas");
var _createCanvas = require("../Utils/createCanvas");
var _createAlphaMapFromAlphaChannel = require("../Utils/createAlphaMapFromAlphaChannel");
var _Deferred = require("../CommonUtils/Deferred");
var _Constants = require("../Constants");
var _disposeMaterial = require("../Utils/disposeMaterial");
var _rememberCameraViewOffset = require("../Utils/rememberCameraViewOffset");
var _restrictCameraMovement = require("../Utils/restrictCameraMovement");
var _isMobileDevice = require("../Utils/isMobileDevice");
var _OrbitControls = _interopRequireDefault(require("./Controls/OrbitControls"));
var _pointerEvent = require("../CommonUtils/pointerEvent");
var _createTextureBuilder = require("../Utils/TextureBuilder/createTextureBuilder");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var MAX_DISTANCE_MULTIPLIER = exports.MAX_DISTANCE_MULTIPLIER = 1.1;
var MIN_DISTANCE_MULTIPLIER = exports.MIN_DISTANCE_MULTIPLIER = 0.1;
var DEFAULT_TEXTURE_SIZE = exports.DEFAULT_TEXTURE_SIZE = 2048;
var Three3D = exports.Three3D = /*#__PURE__*/function (_ThreeBase) {
  _inherits(Three3D, _ThreeBase);
  var _super = _createSuper(Three3D);
  function Three3D() {
    var _this;
    _classCallCheck(this, Three3D);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "DefaultCustomizableMaterialKey", "main_material");
    _defineProperty(_assertThisInitialized(_this), "loadMaterial", function () {
      var _src;
      var promise;
      /**
       * Loads the material from the given path
       * @param {string} src
       * @returns {Promise.<*>}
       */
      return function (src) {
        if (_src === src) {
          // eslint-disable-next-line no-console
          console.log("Material is already loaded: " + src);
          return promise;
        }
        _src = src;
        // eslint-disable-next-line no-console
        console.log("Loading material: " + src);
        promise = new Promise(function (resolve, reject) {
          var _this$getPathAndFileN = _this.getPathAndFileName(src),
            path = _this$getPathAndFileN.path,
            fileName = _this$getPathAndFileN.fileName;
          new _MTLLoader["default"](_this._loadingManager).setPath(path).load(fileName, function (materialCreator) {
            var textureLoadingManager = new _three.LoadingManager(function () {
              // eslint-disable-next-line no-console
              console.log("All textures have been lodaed.");
              resolve(materialCreator);
            }, undefined, _this.onLoadError);
            textureLoadingManager.setURLModifier(function (url) {
              if ((0, _isMobileDevice.isMobileDevice)()) {
                return url.replace(/(https?:\/\/(.+?)\/)/, "$1media/") + "?mobile=1";
              }
              return url;
            });
            materialCreator.setManager(textureLoadingManager);
            materialCreator.preload();
            var isTexture = Object.values(materialCreator.materials).reduce(function (isTexture, material) {
              return Object.values(material).reduce(function (isTexture, propValue) {
                return propValue instanceof _three.Texture || isTexture;
              }, false) || isTexture;
            }, false);
            if (!isTexture) {
              // eslint-disable-next-line no-console
              console.log("Materials do not contain any texture.");
              resolve(materialCreator);
            }
          }, undefined, reject);
        });
        return promise;
      };
    }());
    return _this;
  }
  _createClass(Three3D, [{
    key: "createRenderer",
    value: function createRenderer() {
      var renderer = new _three.WebGLRenderer({
        alpha: true,
        antialias: true,
        gammaInput: true,
        gammaOutput: true
      });
      var realWidth = window.innerWidth * window.devicePixelRatio;
      if ((0, _isMobileDevice.isMobileDevice)() && realWidth >= 1024) {
        renderer.setPixelRatio(1);
      } else {
        renderer.setPixelRatio(window.devicePixelRatio);
      }
      return renderer;
    }
  }, {
    key: "createCamera",
    value: function createCamera() {
      var camera = new _three.PerspectiveCamera(55, 1, 1, 2000);
      camera.position.z = 50;
      return camera;
    }
  }, {
    key: "updateCamera",
    value: function updateCamera(width, height) {
      this.camera.aspect = width / height;
      this.camera.updateProjectionMatrix();
    }
  }, {
    key: "setupDefaultLightning",
    value: function setupDefaultLightning() {
      var ambientLight = new _three.AmbientLight(0xcccccc, 0.4);
      this.scene.add(ambientLight);
      var pointLight = new _three.PointLight(0xffffff, 0.8);
      this.camera.add(pointLight);
    }

    /**
     * @param {HTMLElement} targetElement
     * @param {{}} options Custom options for the controls (see the OrbitControls.js file for details)
     */
  }, {
    key: "setupDefaultControls",
    value: function setupDefaultControls(targetElement) {
      var _this2 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var element = targetElement || this.renderer.domElement;
      this._cleanUpZoomHandler = (0, _pointerEvent.createZoomHandler)(element, function (evt, data) {
        _this2.observable.dispatch(_Constants.EventTypes.Zoomed, _objectSpread({
          originalEvent: evt
        }, data), true);
      });

      // register OrbitControls as the default camera movement handler

      var controls = new _OrbitControls["default"](this.camera, element);
      controls.addEventListener("change", function () {
        if (!_this2._isAnimating) {
          window.cancelAnimationFrame(_this2._renderFrame);
          _this2._renderFrame = window.requestAnimationFrame(_this2.render.bind(_this2));
        }
      });
      controls.enableDamping = true; // an animation loop is required when either damping or auto-rotation are enabled
      controls.enableKeys = false;
      controls.screenSpacePanning = false;
      controls.dampingFactor = 1;
      controls.minDistance = 0.2;
      controls.maxDistance = 10;
      controls.maxPolarAngle = Math.PI;
      Object.assign(controls, options);
      this.controls = controls;
    }

    /**
     * Loads the model from the pre-configured paths
     * Note: this function should be refactored when we have more objects/materials and not only one
     * @param {boolean} loadCameraViews Load the camera views for the model
     * @param {boolean} rerender
     */
  }, {
    key: "loadModel",
    value: function () {
      var _loadModel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var loadCameraViews,
          rerender,
          _this$getModelPaths,
          objPath,
          promises,
          result,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loadCameraViews = _args.length > 0 && _args[0] !== undefined ? _args[0] : true;
              rerender = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;
              _this$getModelPaths = this.getModelPaths(), objPath = _this$getModelPaths.objPath;
              if (!objPath) {
                _context.next = 14;
                break;
              }
              promises = [this.loadObject("".concat(objPath, "/model.obj"))];
              if (loadCameraViews) {
                promises.push(this.loadCameraViewsAdvanced("".concat(objPath, "/cameraviews.dae")));
              }
              this.onLoadStart();
              _context.next = 9;
              return Promise.all(promises);
            case 9:
              result = _context.sent;
              this.onLoadFinished();
              this.observable.dispatch(_Constants.EventTypes.ModelLoaded);
              if (rerender) {
                this.render();
              }
              return _context.abrupt("return", result);
            case 14:
              return _context.abrupt("return", Promise.reject("Cannot load model, the item path is not defined!"));
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadModel() {
        return _loadModel.apply(this, arguments);
      }
      return loadModel;
    }()
    /**
     * Load the camera views (positions and lookAt points) from an obj file
     * For the currently processed view params see the jumpToView method.
     * The value of the param (Vector3) is calculated by taking the geometric center point of the object's
     * bounding sphere.
     * It resolves with an object that contains all the collected data in the following format:
     * {
     *   <name>: {
     *     <param>: Vector3
     *   },
     *   ... and so on
     * }
     * @see jumpToView
     * @param {string} src The url of the obj file that contains the positions.
     * @param {boolean} [setDefault=true] Jump to the default view immediately after the views are processed.
     * @returns {Promise.<{}>}
     */
  }, {
    key: "loadCameraViews",
    value: function () {
      var _loadCameraViews = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(src) {
        var setDefault,
          group,
          children,
          views,
          _iterator,
          _step,
          obj,
          matches,
          viewName,
          viewParam,
          pos,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              setDefault = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : true;
              _context2.next = 3;
              return this.loadObject(src, false);
            case 3:
              group = _context2.sent;
              children = group.children;
              if (!(children && children.length > 0)) {
                _context2.next = 37;
                break;
              }
              views = {};
              _iterator = _createForOfIteratorHelper(children);
              _context2.prev = 8;
              _iterator.s();
            case 10:
              if ((_step = _iterator.n()).done) {
                _context2.next = 25;
                break;
              }
              obj = _step.value;
              if (obj instanceof _three.Mesh) {
                _context2.next = 14;
                break;
              }
              return _context2.abrupt("continue", 23);
            case 14:
              matches = ("" + obj.name).toLowerCase().match(/(.+)_(position|lookat)$/);
              if (matches) {
                _context2.next = 18;
                break;
              }
              // eslint-disable-next-line no-console
              console.warn("Camera view object skipped: ".concat(obj.name));
              return _context2.abrupt("continue", 23);
            case 18:
              viewName = matches[1];
              viewParam = matches[2];
              obj.geometry.computeBoundingSphere();
              pos = obj.geometry.boundingSphere.center.clone();
              views[viewName] = _objectSpread(_objectSpread({}, views[viewName]), {}, _defineProperty({}, viewParam, pos));
            case 23:
              _context2.next = 10;
              break;
            case 25:
              _context2.next = 30;
              break;
            case 27:
              _context2.prev = 27;
              _context2.t0 = _context2["catch"](8);
              _iterator.e(_context2.t0);
            case 30:
              _context2.prev = 30;
              _iterator.f();
              return _context2.finish(30);
            case 33:
              this.cameraViews = views;
              if (setDefault) {
                this.jumpToView("default", false);
              }
              this.setControlsDistanceMinMax();
              return _context2.abrupt("return", views);
            case 37:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[8, 27, 30, 33]]);
      }));
      function loadCameraViews(_x) {
        return _loadCameraViews.apply(this, arguments);
      }
      return loadCameraViews;
    }()
    /**
     * Loads the camera views (positions, rotations and lookAt points) from a Collada file (.dae)
     * The main difference to loadCameraViews is that it reads the camera rotation and adds it to the params.
     * @param {string} src The url of the obj file that contains the positions.
     * @param {boolean} [setDefault=true] Jump to the default view immediately after the views are processed.
     * @returns {Promise.<{}>}
     */
  }, {
    key: "loadCameraViewsAdvanced",
    value: function () {
      var _loadCameraViewsAdvanced = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(src) {
        var setDefault,
          loader,
          _this$getPathAndFileN2,
          path,
          fileName,
          _yield$Promise,
          scene,
          views,
          _args4 = arguments;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              setDefault = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : true;
              loader = new _ColladaLoader["default"](this._loadingManager);
              _this$getPathAndFileN2 = this.getPathAndFileName(src), path = _this$getPathAndFileN2.path, fileName = _this$getPathAndFileN2.fileName;
              _context4.next = 5;
              return new Promise(function (resolve, reject) {
                loader.setPath(path).load(fileName, /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(object) {
                    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                      while (1) switch (_context3.prev = _context3.next) {
                        case 0:
                          resolve(object);
                        case 1:
                        case "end":
                          return _context3.stop();
                      }
                    }, _callee3);
                  }));
                  return function (_x3) {
                    return _ref.apply(this, arguments);
                  };
                }(), _ThreeBase2.onProgress, reject);
              });
            case 5:
              _yield$Promise = _context4.sent;
              scene = _yield$Promise.scene;
              views = {};
              scene.traverse(function (obj) {
                var matches = ("" + obj.name).toLowerCase().match(/(.+)_(position|lookat)$/);
                if (matches) {
                  var viewName = matches[1];
                  var viewParam = matches[2];
                  var params = _objectSpread(_objectSpread({}, views[viewName]), {}, _defineProperty({}, viewParam, obj.position.clone()));
                  // if it's the position, create a custom up vector from its rotation
                  if (viewParam === "position") {
                    params.orientation = _three.Object3D.DefaultUp.clone().applyEuler(obj.rotation);
                  }
                  views[viewName] = params;
                }
              });
              this.cameraViews = views;
              if (setDefault) {
                this.jumpToView("default", false);
              }
              this.setControlsDistanceMinMax();
              return _context4.abrupt("return", views);
            case 13:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function loadCameraViewsAdvanced(_x2) {
        return _loadCameraViewsAdvanced.apply(this, arguments);
      }
      return loadCameraViewsAdvanced;
    }()
  }, {
    key: "loadObject",
    value:
    /**
     * Loads the object from the given path.
     * It adds the object to the scene immediately (by default).
     * @param {string} src
     * @param {boolean} addToScene
     * @returns {Promise<Group>}
     */
    function loadObject(src) {
      var _this3 = this;
      var addToScene = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var objLoader = new _OBJLoader["default"](this._loadingManager);
      var _this$getPathAndFileN3 = this.getPathAndFileName(src),
        path = _this$getPathAndFileN3.path,
        fileName = _this$getPathAndFileN3.fileName;
      return new Promise(function (resolve, reject) {
        objLoader.setPath(path).load(fileName, /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(object) {
            return _regeneratorRuntime().wrap(function _callee5$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return _this3.updateMaterial(object);
                case 2:
                  if (addToScene) {
                    _this3.scene.add(object);
                  }
                  resolve(object);
                case 4:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          }));
          return function (_x4) {
            return _ref2.apply(this, arguments);
          };
        }(), _ThreeBase2.onProgress, reject);
      });
    }
  }, {
    key: "dispatchMaterialUpdateEvent",
    value: function () {
      var _dispatchMaterialUpdateEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var options,
          _options$screenshot,
          screenshot,
          eventParams,
          _args6 = arguments;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              options = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
              _options$screenshot = options.screenshot, screenshot = _options$screenshot === void 0 ? false : _options$screenshot;
              eventParams = {
                variant: this._materialVariantPath,
                screenshot: screenshot
              }; // the redrawing of the areas can be synced if the event handler returns a Promise
              _context6.next = 5;
              return this.observable.dispatch(_Constants.EventTypes.MaterialUpdated, eventParams);
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function dispatchMaterialUpdateEvent() {
        return _dispatchMaterialUpdateEvent.apply(this, arguments);
      }
      return dispatchMaterialUpdateEvent;
    }()
  }, {
    key: "updateMaterial",
    value: function () {
      var _updateMaterial = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var targetObject,
          options,
          _this$getModelPaths2,
          mtlPath,
          materialCreator,
          _args7 = arguments;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              targetObject = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : this.scene;
              options = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
              // eslint-disable-next-line no-console
              console.log("Updating materials...");
              _this$getModelPaths2 = this.getModelPaths(), mtlPath = _this$getModelPaths2.mtlPath;
              if (mtlPath) {
                _context7.next = 7;
                break;
              }
              // eslint-disable-next-line no-console
              console.log("Missing material path!");
              return _context7.abrupt("return");
            case 7:
              _context7.next = 9;
              return this.loadMaterial("".concat(mtlPath, "/materials.mtl"));
            case 9:
              materialCreator = _context7.sent;
              this.guessCustomizableMaterialNameIfNotSet(materialCreator.materials);
              this.findCustomizableMaterials(materialCreator.materials);
              this.applyMaterials(materialCreator.materials, targetObject);
              _context7.next = 15;
              return this.dispatchMaterialUpdateEvent(options);
            case 15:
              return _context7.abrupt("return", materialCreator);
            case 16:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function updateMaterial() {
        return _updateMaterial.apply(this, arguments);
      }
      return updateMaterial;
    }()
    /**
     * Sets a single customizable material name that can be used for drawing on the texture
     * @param matName
     */
  }, {
    key: "setCustomizableMaterialName",
    value: function setCustomizableMaterialName(matName) {
      this._customizableMaterialKeys = [matName];
    }
  }, {
    key: "guessCustomizableMaterialNameIfNotSet",
    value: function guessCustomizableMaterialNameIfNotSet(materials) {
      if (this._customizableMaterialKeys.length === 0) {
        var materialName = this.DefaultCustomizableMaterialKey;
        // if there is no default material, pick the first from the list (fallback)
        if (!materials[materialName]) {
          var firstMaterialName = Object.keys(materials).find(function (matName) {
            var material = materials[matName];
            if (material.map && material.map.image) {
              return true;
            }
          });
          if (firstMaterialName) {
            materialName = firstMaterialName;
          }
        }
        this.setCustomizableMaterialName(materialName);
      }
    }

    /**
     * Find the objects using the given materials and update them
     * @param materials
     * @param targetObject
     */
  }, {
    key: "applyMaterials",
    value: function applyMaterials(materials, targetObject) {
      targetObject && targetObject.traverse && targetObject.traverse(function (object) {
        if (object.material && object.material.name) {
          var requiredMaterial = materials[object.material.name];
          if (requiredMaterial && object.material !== requiredMaterial) {
            (0, _disposeMaterial.disposeMaterial)(object.material);
            object.material = requiredMaterial;
          }
        }
      });
    }

    /**
     * Finds the marked customizable materials and prepares a canvas for drawing on the texture
     * @param {*} materialsObj
     */
  }, {
    key: "findCustomizableMaterials",
    value: function findCustomizableMaterials(materialsObj) {
      // eslint-disable-next-line no-console
      console.log("Looking for customizable materials...");
      var _iterator2 = _createForOfIteratorHelper(this._customizableMaterialKeys),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;
          var mat = materialsObj[key];
          if (mat) {
            this.prepareCustomCanvasForMaterial(mat);
            var index = (0, _findIndex["default"])(this._customizableMaterials, {
              name: key
            });
            if (index === -1) {
              this._customizableMaterials.push(mat);
            } else if (this._customizableMaterials[index] !== mat) {
              (0, _disposeMaterial.disposeMaterial)(this._customizableMaterials[index]);
              this._customizableMaterials[index] = mat;
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    /**
     * Creates the canvas for the material texture and draws the original image on it
     * @param {Material} material
     */
  }, {
    key: "prepareCustomCanvasForMaterial",
    value: function prepareCustomCanvasForMaterial(material) {
      if (material && material.map && material.map.image) {
        // init canvas for diffuse map
        (0, _initTextureCanvas.initTextureCanvas)(material.map);
        material.map.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
        // init canvas for alpha map
        if (material.alphaMap) {
          (0, _initTextureCanvas.initTextureCanvas)(material.alphaMap);
        }
      } else {
        throw new Error("Cannot prepare canvas for material: ".concat(material.name));
      }
    }
  }, {
    key: "getCanvasContextForTexture",
    value: function getCanvasContextForTexture(texture) {
      var originalImage = texture.originalImage,
        canvas = texture.image;
      if (texture.originalImage && canvas instanceof HTMLCanvasElement) {
        var ctx = canvas.getContext("2d");
        return {
          ctx: ctx,
          originalImage: originalImage,
          canvas: canvas,
          texture: texture
        };
      }
      throw new Error("Cannot get drawing context for canvas. Is it prepared already?");
    }

    /**
     * Moves the camera to the given position and target (look at point)
     * @param {Vector3|undefined} position The new position
     * @param {Vector3|undefined} orientation The new orientation of the camera (up vector)
     * @param {Vector3|undefined} target The new look at point
     * @param {number|undefined} fov The new fov
     * @param {{[position]: number, [target]: number, [orientation]: number, [fov]: number}} duration The animation duration in ms
     * @requires TWEEN
     */
  }, {
    key: "moveCamera",
    value: function moveCamera(position, orientation, target, fov) {
      var _this4 = this;
      var duration = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      this.cleanUpCameraAnimations();
      var animationDef = new _Deferred.DeferredGroup();
      if (position) {
        // use spherical coordinates to keep the distance from the object
        var sp0 = new _three.Spherical();
        sp0.setFromVector3(this.camera.position);
        var sp1 = new _three.Spherical();
        sp1.setFromVector3(position);
        // always take the shorter way around the target
        if (Math.abs(sp1.theta - sp0.theta) > Math.PI) {
          sp1.theta += (sp1.theta > 0 ? -1 : 1) * Math.PI * 2;
        }
        new _tween["default"].Tween(sp0, this.cameraTweenGroup).to(sp1, duration.position || 1000).easing(_tween["default"].Easing.Quadratic.Out).onUpdate(function () {
          _this4.camera.position.setFromSpherical(sp0);
        }).onComplete(animationDef.createResolver()).start();
      }
      if (orientation) {
        new _tween["default"].Tween(this.camera.up, this.cameraTweenGroup).to(orientation, duration.orientation || 700).easing(_tween["default"].Easing.Quadratic.Out).onComplete(animationDef.createResolver()).start();
      }
      if (this.controls && target) {
        new _tween["default"].Tween(this.controls.target, this.cameraTweenGroup).to(target, duration.target || 500).easing(_tween["default"].Easing.Quadratic.Out).onComplete(animationDef.createResolver()).start();
      }
      if (fov) {
        new _tween["default"].Tween(this.camera, this.cameraTweenGroup).to({
          fov: fov
        }, duration.fov || 700).easing(_tween["default"].Easing.Quadratic.Out).onUpdate(function () {
          _this4.camera.updateProjectionMatrix();
        }).start();
      }
      animationDef.then(function () {
        return _this4.stopAnimation("camera");
      });
      this.startAnimation("camera");
    }

    /**
     * Jump to the selected view
     * Note: the available views are loaded from an additional obj file
     * @see loadCameraViews
     * @see moveCamera
     * @see setCameraPosition
     * @param {string} viewName The name of the view object in this.cameraViews
     * @param {boolean} [animate=true] Use animation or set it directly
     * @param {{[position]: number, [target]: number}} duration The animation duration in ms
     */
  }, {
    key: "jumpToView",
    value: function jumpToView(viewName) {
      var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var viewNameSafe = ("" + viewName).toLowerCase();
      var view = this.cameraViews[viewNameSafe];
      if (!view) {
        // eslint-disable-next-line no-console
        console.error("Camera view does not exist: ".concat(viewNameSafe));
        return;
      }
      var _this$cameraViews$def = _objectSpread(_objectSpread({}, this.cameraViews["default"]), view),
        position = _this$cameraViews$def.position,
        orientation = _this$cameraViews$def.orientation,
        target = _this$cameraViews$def.lookat,
        fov = _this$cameraViews$def.fov;
      if (animate) {
        this.moveCamera(position, orientation, target, fov, duration);
      } else {
        this.setCameraPosition(position, orientation, target, fov);
      }
    }

    /**
     * Sets the camera position and renders the scene if it's not animating
     * @param {{x: number|undefined, y: number|undefined, z: number|undefined}} position
     * @param {{x: number|undefined, y: number|undefined, z: number|undefined}} orientation
     * @param {{x: number|undefined, y: number|undefined, z: number|undefined}} target
     * @param {number|undefined} fov
     */
  }, {
    key: "setCameraPosition",
    value: function setCameraPosition() {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        y: 30
      };
      var orientation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        y: 10
      };
      var fov = arguments.length > 3 ? arguments[3] : undefined;
      if (!this.camera) {
        throw new Error("The camera must be available for the setCameraPosition call!");
      }
      Object.assign(this.camera.position, position);
      Object.assign(this.camera.up, orientation);
      if (fov) {
        this.camera.fov = fov;
        this.camera.updateProjectionMatrix();
      }
      if (this.controls && this.controls.target) {
        Object.assign(this.controls.target, target);
        if (!this.isAnimating()) {
          this.controls.update();
        }
      }
    }
  }, {
    key: "setupScreenshots",
    value: function setupScreenshots() {
      // do initial steps before actually starting to create screenshots

      // it has to return a "restore" function
      return function () {};
    }
  }, {
    key: "getScreenshots",
    value: function () {
      var _getScreenshots = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(callback, _ref3) {
        var _this5 = this;
        var viewList, variantList, size, removeTempOverlay, restoreCameraViewOffset, origVariantPath, origPosition, origOrientation, origTarget, origSize, origPixelRatio, restoreOriginalValues, restoreScreenshotSetup, width, height, screenshots, views, viewKeyList, _iterator3, _step3, variant, data, _iterator4, _step4, viewKey, view, position, orientation, target, fov;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              viewList = _ref3.viewList, variantList = _ref3.variantList, size = _ref3.size;
              if (this.renderer) {
                _context9.next = 3;
                break;
              }
              return _context9.abrupt("return", callback({}));
            case 3:
              this._screenshottingInProgress = true;
              this.endAnimation();
              _context9.next = 7;
              return this.animationRunning();
            case 7:
              _context9.next = 9;
              return this.createTempOverlay();
            case 9:
              removeTempOverlay = _context9.sent;
              restoreCameraViewOffset = (0, _rememberCameraViewOffset.rememberCameraViewOffset)(this.camera); // store original state values
              origVariantPath = this._materialVariantPath;
              origPosition = this.camera.position.clone();
              origOrientation = this.camera.up.clone();
              origTarget = this.controls ? this.controls.target.clone() : false;
              origSize = new _three.Vector2();
              this.renderer.getSize(origSize);
              origPixelRatio = this.renderer.getPixelRatio();
              restoreOriginalValues = /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        _this5._screenshottingInProgress = false;
                        _this5.renderer.setSize(origSize.width, origSize.height);
                        _this5.renderer.setPixelRatio(origPixelRatio);
                        _this5.updateCamera(origSize.width, origSize.height);
                        _this5.setCameraPosition(origPosition, origOrientation, origTarget);
                        restoreCameraViewOffset();
                        _this5._materialVariantPath = origVariantPath;
                        _context8.next = 9;
                        return _this5.updateMaterial();
                      case 9:
                        _this5.render();
                        removeTempOverlay();
                      case 11:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                return function restoreOriginalValues() {
                  return _ref4.apply(this, arguments);
                };
              }();
              _context9.next = 21;
              return this.setupScreenshots();
            case 21:
              restoreScreenshotSetup = _context9.sent;
              // get the size from the size param, or use default values
              width = (size === null || size === void 0 ? void 0 : size.width) || 1024;
              height = (size === null || size === void 0 ? void 0 : size.height) || 768;
              screenshots = {};
              views = this.screenshotViews || this.cameraViews; // if the viewList option is provided, use it as keys instead of the list of all views
              viewKeyList = viewList instanceof Array && viewList.length > 0 ? viewList : Object.keys(views);
              _iterator3 = _createForOfIteratorHelper(variantList);
              _context9.prev = 28;
              _iterator3.s();
            case 30:
              if ((_step3 = _iterator3.n()).done) {
                _context9.next = 77;
                break;
              }
              variant = _step3.value;
              if (!this._abortScreenshotting) {
                _context9.next = 36;
                break;
              }
              _context9.next = 35;
              return restoreOriginalValues();
            case 35:
              return _context9.abrupt("return", _context9.sent);
            case 36:
              data = {};
              this.setMaterialVariantPath(variant);
              _context9.prev = 38;
              _context9.next = 41;
              return this.updateMaterial(this.scene, {
                screenshot: true
              });
            case 41:
              _context9.next = 46;
              break;
            case 43:
              _context9.prev = 43;
              _context9.t0 = _context9["catch"](38);
              return _context9.abrupt("continue", 75);
            case 46:
              _iterator4 = _createForOfIteratorHelper(viewKeyList);
              _context9.prev = 47;
              _iterator4.s();
            case 49:
              if ((_step4 = _iterator4.n()).done) {
                _context9.next = 66;
                break;
              }
              viewKey = _step4.value;
              if (!this._abortScreenshotting) {
                _context9.next = 55;
                break;
              }
              _context9.next = 54;
              return restoreOriginalValues();
            case 54:
              return _context9.abrupt("return", _context9.sent);
            case 55:
              view = views[viewKey];
              position = view.position, orientation = view.orientation, target = view.lookat, fov = view.fov; // set the camera to the screenshot size
              this.renderer.setPixelRatio(1);
              this.renderer.setSize(width, height);
              this.updateCamera(width, height);
              this.camera.clearViewOffset();
              this.setCameraPosition(position, orientation, target, fov);
              this.render();
              data[viewKey] = this.renderer.domElement.toDataURL("image/png");
            case 64:
              _context9.next = 49;
              break;
            case 66:
              _context9.next = 71;
              break;
            case 68:
              _context9.prev = 68;
              _context9.t1 = _context9["catch"](47);
              _iterator4.e(_context9.t1);
            case 71:
              _context9.prev = 71;
              _iterator4.f();
              return _context9.finish(71);
            case 74:
              screenshots[variant] = data;
            case 75:
              _context9.next = 30;
              break;
            case 77:
              _context9.next = 82;
              break;
            case 79:
              _context9.prev = 79;
              _context9.t2 = _context9["catch"](28);
              _iterator3.e(_context9.t2);
            case 82:
              _context9.prev = 82;
              _iterator3.f();
              return _context9.finish(82);
            case 85:
              _context9.next = 87;
              return restoreScreenshotSetup();
            case 87:
              _context9.next = 89;
              return restoreOriginalValues();
            case 89:
              callback(screenshots);
            case 90:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[28, 79, 82, 85], [38, 43], [47, 68, 71, 74]]);
      }));
      function getScreenshots(_x5, _x6) {
        return _getScreenshots.apply(this, arguments);
      }
      return getScreenshots;
    }()
  }, {
    key: "calculateTextureScaling",
    value: function calculateTextureScaling(textureImage) {
      return textureImage.width / DEFAULT_TEXTURE_SIZE;
    }
  }, {
    key: "textureHitFormatter",
    value: function textureHitFormatter(intersect, position) {
      var x = position.x,
        y = position.y,
        width = position.width,
        height = position.height;
      return {
        width: DEFAULT_TEXTURE_SIZE,
        height: DEFAULT_TEXTURE_SIZE,
        x: x / width * DEFAULT_TEXTURE_SIZE,
        y: y / height * DEFAULT_TEXTURE_SIZE
      };
    }

    /**
     * Calls the given drawing function for custom drawing implementations
     * It provides the drawing context and the original texture image to the callback function.
     * It also invalidates the texture to make it update in the next render.
     * Calls the render function if it's not animating continuously.
     * @param {function} drawingFn
     * @param {boolean} updateAlpha
     * @param {boolean} clearTexture
     * @param {string|undefined} materialName If not provided it uses the first customizable material
     */
  }, {
    key: "getDrawingContext",
    value: function () {
      var _getDrawingContext = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(drawingFn) {
        var updateAlpha,
          clearTexture,
          materialName,
          material,
          _this$getCanvasContex,
          ctx,
          canvas,
          originalImage,
          texture,
          scaling,
          getTextureBuilder,
          _createWorkingCanvas,
          _createWorkingCanvas2,
          tmpCanvas,
          tmpCtx,
          _args10 = arguments;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              updateAlpha = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : false;
              clearTexture = _args10.length > 2 && _args10[2] !== undefined ? _args10[2] : false;
              materialName = _args10.length > 3 && _args10[3] !== undefined ? _args10[3] : undefined;
              material = materialName ? this.findMaterialByName(materialName) : (0, _first["default"])(this._customizableMaterials);
              if (!(!material || !material.map || !material.map.image)) {
                _context10.next = 6;
                break;
              }
              throw new Error("Cannot get drawing context for material: ".concat(materialName, "! Is it prepared already?"));
            case 6:
              _this$getCanvasContex = this.getCanvasContextForTexture(material.map), ctx = _this$getCanvasContex.ctx, canvas = _this$getCanvasContex.canvas, originalImage = _this$getCanvasContex.originalImage, texture = _this$getCanvasContex.texture;
              scaling = this.calculateTextureScaling(canvas);
              getTextureBuilder = (0, _createTextureBuilder.createTextureBuilder)(originalImage, {
                scaling: scaling
              });
              if (clearTexture) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                // draw the texture image on the drawing canvas to clear the previous state
                ctx.drawImage(originalImage, 0, 0);
              }
              if (!(updateAlpha && material.alphaMap)) {
                _context10.next = 18;
                break;
              }
              // create a temporary canvas
              _createWorkingCanvas = (0, _createCanvas.createWorkingCanvas)(canvas), _createWorkingCanvas2 = _slicedToArray(_createWorkingCanvas, 2), tmpCanvas = _createWorkingCanvas2[0], tmpCtx = _createWorkingCanvas2[1]; // do the drawing on a temporary canvas first, so we can get the alpha values
              _context10.next = 14;
              return drawingFn(tmpCtx, getTextureBuilder);
            case 14:
              // copy the temp canvas on the diffuse map
              ctx.drawImage(tmpCanvas, 0, 0);
              this.updateAlphaMap(material.alphaMap, tmpCanvas);
              _context10.next = 20;
              break;
            case 18:
              _context10.next = 20;
              return drawingFn(ctx, getTextureBuilder);
            case 20:
              texture.needsUpdate = true;
              if (!this.isAnimating()) {
                this.render();
              }
            case 22:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getDrawingContext(_x7) {
        return _getDrawingContext.apply(this, arguments);
      }
      return getDrawingContext;
    }()
  }, {
    key: "updateAlphaMap",
    value: function updateAlphaMap(texture, srcCanvas) {
      var _this$getCanvasContex2 = this.getCanvasContextForTexture(texture),
        ctx = _this$getCanvasContex2.ctx,
        canvas = _this$getCanvasContex2.canvas,
        originalImage = _this$getCanvasContex2.originalImage;
      ctx.drawImage(originalImage, 0, 0); // draw the original alpha image on the canvas
      (0, _createAlphaMapFromAlphaChannel.createAlphaMapFromAlphaChannel)(srcCanvas, canvas);
      texture.needsUpdate = true;
    }
  }, {
    key: "lockHorizontalRotation",
    value: function lockHorizontalRotation(fixedAngle) {
      if (!this.controls) {
        throw new Error("The controls should be available for the lockHorizontalRotation call!");
      }
      this.controls.minAzimuthAngle = fixedAngle;
      this.controls.maxAzimuthAngle = fixedAngle;
    }
  }, {
    key: "lockVerticalRotation",
    value: function lockVerticalRotation(fixedAngle) {
      if (!this.controls) {
        throw new Error("The controls should be available for the lockVerticalRotation call!");
      }
      this.controls.minPolarAngle = fixedAngle;
      this.controls.maxPolarAngle = fixedAngle;
    }
  }, {
    key: "setControlsDistanceMinMax",
    value: function setControlsDistanceMinMax() {
      var _this$cameraViews$def2 = this.cameraViews["default"],
        position = _this$cameraViews$def2.position,
        lookat = _this$cameraViews$def2.lookat;
      var d = position.distanceTo(lookat);
      this.controls.maxDistance = d * MAX_DISTANCE_MULTIPLIER;
      this.controls.minDistance = d * MIN_DISTANCE_MULTIPLIER;
      this.controls.update();
    }
  }, {
    key: "restrictUserMovement",
    value: function restrictUserMovement() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _angleRad$options = _objectSpread({
          angleRad: Math.PI * 0.1
        }, options),
        angleRad = _angleRad$options.angleRad;
      this._releaseUserMovementRestriction = (0, _restrictCameraMovement.restrictOrbitControls)(this.controls).byAngle(angleRad);
    }
  }, {
    key: "freeUserMovement",
    value: function freeUserMovement() {
      if (this._releaseUserMovementRestriction) {
        this._releaseUserMovementRestriction();
        delete this._releaseUserMovementRestriction;
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this._cleanUpZoomHandler) {
        this._cleanUpZoomHandler();
      }
      _get(_getPrototypeOf(Three3D.prototype), "dispose", this).call(this);
    }
  }]);
  return Three3D;
}(_ThreeBase2.ThreeBase);